import Vue from 'vue'
export default {
    install(Vue) {
		/**
		 * 新窗口打开路由页面
		 * @path 地址
		 * @param 参数
		 */
		Vue.prototype.openPage = function(path, param) {
			let routeUrl = this.$router.resolve({
				  path: path,
				  query: param
			 });
			 window.open(routeUrl.href, '_blank');
		},
		
		/**
		 * 打开路由页面
		 * @path 地址
		 * @query 参数
		 */
		Vue.prototype.goToPage = function(path, query={}) {
			this.$router.push({
				path,
				query
			})
		},
		
		/**
		 * 上传图片文件统一验证
		 * @file 文件
		 * @size 大小，默认2M
		 */
		Vue.prototype.beforeAvatarUploadCommon = function (file, size = 2) {
		  const FileExt = file.name.replace(/.+\./, "");
		  const is2M = file.size / 1024 / 1024 < size;
		  if (
		      ["jpg", "png", "gif"].indexOf(FileExt.toLowerCase()) === -1 ||
		      !is2M
		  ) {
		    this.$message({
		      type: "warning",
		      message: `请上传 jpg|png|gif 图像，大小不超过${size}MB`
		    });
		    return false;
		  }else{
			  return true;
		  }
		},
		
		/**
		 * 将时间戳改为日期显示
		 * @timestamp 时间戳
		 * @status 是否显示时分秒，默认不显示
		 */
		Vue.prototype.timestampConvertDate = function(timestamp, status=false) {
			// 创建一个新的 Date() 对象并传入时间戳作为参数
			var dateObj = new Date(timestamp);
			// 获取年、月、日等信息
			var year = dateObj.getFullYear(); // 年份
			var month = dateObj.getMonth() + 1; // 月份（注意要加上1）
			var day = dateObj.getDate(); // 日期
			var hours = dateObj.getHours(); // 小时
			var minutes = dateObj.getMinutes(); // 分钟
			var seconds = dateObj.getSeconds(); // 秒钟
			return status ? year + "-" + month + "-" + day +' '+hours + ":" + minutes + ":" + seconds : year + "-" + month + "-" + day;
		},
		
		// 将附件转为base64
		Vue.prototype.dataURLtoFileBase64 = function(event, fn) {
			var event = event || window.event;
			    var file = event.target.files[0];
			    var reader = new FileReader();
			    //转base64
			    reader.onload = function(e) {
					fn && fn(e.target.result); //将图片路径赋值给src 
			    }
			    reader.readAsDataURL(file);
		}
		
    }
}